import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useState } from "react";
import { alert } from "services/alert";
import { resetPassword } from "sources/account";

const ResetPassword = () => {
    const router = useRouter();
    const [success, setSuccess] = useState();
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
        userId: router.query.userId,
        code: router.query.code,
    });
    const [loading, setLoading] = useState(false);
    const submitForm = (e) => {
        e.preventDefault();
        setLoading(true);
        resetPassword(formData).then((res) => {
            setLoading(false);
            if (res) {
                setSuccess(true);
                setTimeout(() => {
                    router.push(paths.login);
                }, 500);
            } else {
                alert({ type: "error", message: "При сбросе пароля произошла ошибка", title: "Ошибка" });
            }
        });
    };
    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                {loading && (
                    <div className="loader-snippet--disable-loader">
                        <Loader />
                    </div>
                )}
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--small">
                    <div className="identity-column">
                        <h1 className="identity-container__title" />
                        <div className="identity-column__title">Сброс пароля</div>
                        {success ? (
                            <div className="col-12 text-center">Пароль сброшен.</div>
                        ) : (
                            <form className="identity-form" onSubmit={submitForm}>
                                <div className="identity-field">
                                    <div className="col-12">
                                        <input
                                            required
                                            className="form-control"
                                            type="password"
                                            value={formData.password}
                                            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                            placeholder="Введите пароль"
                                        />
                                    </div>
                                </div>
                                <div className="identity-field">
                                    <div className="col-12">
                                        <input
                                            required
                                            className="form-control"
                                            type="password"
                                            value={formData.confirmPassword}
                                            onChange={(e) =>
                                                setFormData({ ...formData, confirmPassword: e.target.value })
                                            }
                                            placeholder="Повторите пароль"
                                        />
                                    </div>
                                </div>
                                <div className="identity-field col-12">
                                    <button
                                        className="identity-form__button identity-form__button--yellow identity-form__button--text-small"
                                        type="submit"
                                    >
                                        Сбросить пароль
                                    </button>
                                </div>
                                <div className="identity-form__button-group col-12">
                                    <a
                                        className="identity-form__link identity-form__link--centered cursor-pointer"
                                        onClick={() => router.push(paths.login)}
                                    >
                                        Вспомнили пароль?
                                    </a>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
